import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { HeaderModel } from "src/app/_component/header/header.model";
import { UserService } from "src/app/_services";
import { BookingService } from "src/app/_services/booking.service";
import { HeaderService } from "src/app/_services/header.service";
import { ThisPlatform } from "src/app/_services/platform.service";
import { SpaceService } from "src/app/_services/space.service";
import { SpaceType } from "src/app/_types/space-type";
import { SpaceDateFilterService } from "../../_component/_space/space-date-filter/space-date-filter.service";
import { SpaceFilter } from "../../_component/_space/space-filter/space-filter.model";
import { SpaceFilterService } from "../../_component/_space/space-filter/space-filter.service";

@Component({
  selector: "app-add-reservation",
  templateUrl: "./add-reservation.page.html",
  styleUrls: ["./add-reservation.page.scss"],
})
export class AddReservationPage implements OnInit {
  constructor(
    private userService: UserService,
    public p: ThisPlatform,
    private translateServ: TranslateService,
    private spaceFilterServ: SpaceFilterService,
    private spaceDateFilterService: SpaceDateFilterService,
    private bookingService: BookingService,
    private spaceService: SpaceService,
    private headerServ: HeaderService,
  ) {}

  spaceType: SpaceType = SpaceType.Parking;

  eventsSubject: Subject<void> = new Subject<void>();

  headerInit: HeaderModel = {
    title: this.translateServ.instant("SPACE.BOOK_SPACE"),
    userSettingsBreakpoint: 1250,
  };

  showAll = false;
  async ngOnInit() {
    await this.userService.getPermision();
    this.showAll = true;
  }

  ionViewWillEnter() {
    this.headerServ.setHeaderInit(this.headerInit);
  }

  ionViewWillLeave() {
    this.spaceFilterServ.filterDetails = new SpaceFilter();
    this.spaceDateFilterService.filterLoadedFloors = [];
    this.bookingService.bookingsCounter = null;
    this.spaceService.assignmentsCounter = null;
    this.eventsSubject.next();
  }
}
